import { render, staticRenderFns } from "./ProductBulkAdd.vue?vue&type=template&id=00d03c69&scoped=true&"
import script from "./ProductBulkAdd.vue?vue&type=script&lang=ts&"
export * from "./ProductBulkAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ProductBulkAdd.vue?vue&type=style&index=0&id=00d03c69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d03c69",
  null
  
)

export default component.exports